import axios from 'axios'
import store from '@/store'

const API_BASE_URL = process.env.VUE_APP_API_URL || 'https://clubtest.intrare.app'

function getHeaders () {
  return {
    'Content-Type': 'application/json',
    'Authorization': `Token ${store.getters.getToken}`
  }
}

export const courseAgreementsAPI = {
  list (params = {}) {
    return axios.get(`${API_BASE_URL}/golf/course-agreements/`, {
      headers: getHeaders(),
      params
    })
  },

  active () {
    return axios.get(`${API_BASE_URL}/golf/course-agreements/active/`, {
      headers: getHeaders()
    })
  },

  get (id) {
    return axios.get(`${API_BASE_URL}/golf/course-agreements/${id}/`, {
      headers: getHeaders()
    })
  },

  create (data) {
    return axios.post(`${API_BASE_URL}/golf/course-agreements/`, data, {
      headers: getHeaders()
    })
  },

  update (id, data) {
    return axios.patch(`${API_BASE_URL}/golf/course-agreements/${id}/`, data, {
      headers: getHeaders()
    })
  },

  delete (id) {
    return axios.delete(`${API_BASE_URL}/golf/course-agreements/${id}/`, {
      headers: getHeaders()
    })
  },

  downloadScorecard (reservationId) {
    return axios.get(
      `${API_BASE_URL}/golf/golf-reservations/${reservationId}/download_scorecard/`,
      {
        headers: getHeaders(),
        responseType: 'blob'
      }
    )
  }
}
